import { PropsWithChildren } from 'react';

import styles from './SingleColumnLayout.module.scss';

type Props = PropsWithChildren<{
	className?: string;

	/**
	 * class to be applied to the inner content wrapper.
	 */
	contentClassName?: string;

	/**
	 * if this property is specified the background image to the
	 * left and right of the column will not be displayed.
	 */
	noBackground?: true;
}>;

/**
 * Component used to display the single column layout used in the weather and traffic screens.
 */
export function SingleColumnLayout({ children, contentClassName = '', className = '', noBackground }: Props) {
	const showBackgroundMap = noBackground !== true;

	return (
		<div className={`${styles.main} ${className} ${showBackgroundMap ? styles.map : ''}`}>
			<div className={`${contentClassName} ${styles.content}`}>{children}</div>
		</div>
	);
}
